import { observable, action, makeObservable, runInAction } from "mobx";
import { CoreStore, handleStoreState } from "Stores/RESTStore/CoreStore";
import { API_URL } from "General/APIEndpoints";
import { API } from "General/API";
import { userDataStore } from "./UserStore";
import { message } from "antd";
import i18n, { I18N_NS } from "Config/i18n";

class SystemRolesStore extends CoreStore {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Array<API_Systemrecht> = [];
  isSystemRolesModalVisible: boolean = false;

  constructor() {
    super();

    makeObservable(this, {
      data: observable,
      isSystemRolesModalVisible: observable,
      toggleSystemRolesModal: action.bound,
      updateSystemRole: action.bound,
      searchSystemRole: action.bound,
      fetch: action.bound,
      clear: action.bound,
    });
    this.isSystemRolesModalVisible = false;
  }

  url() {
    return API_URL.ADMIN.getSystemroles();
  }

  clear() {
    this.data = null;
  }

  @handleStoreState()
  async fetch(parameter?: Object) {
    try {
      const response = await API.getData(this.url(), parameter);
      if (response) {
        runInAction(() => {
          this.data = response;
        });
      }
    } catch (error) {
      throw error;
    }
  }

  async updateSystemRole(userId: string, recht: string) {
    try {
      if (userDataStore.state === "RAW") {
        await userDataStore.fetch();
      }
      const searchValue = userId?.trim();
      const currentUser: API_User = userDataStore.data.find(
        (item) => String(item.id) === searchValue || item.userId === searchValue
      );
      let params: API_Systemrecht = {};
      if (currentUser) {
        params = {
          id: currentUser.id,
          userId: currentUser.userId,
          recht: recht,
        };
        await API.editData(API_URL.ADMIN.updateSystemrole(), params);
        this.fetch();
        this.toggleSystemRolesModal();
        message.success(i18n.t("System role assigned successfully", { ns: I18N_NS.ADMIN }) as string);
      } else {
        message.error(i18n.t("No Users found", { ns: I18N_NS.PROJECT }) as string);
      }
    } catch (error) {
      throw error;
    }
  }

  async searchSystemRole(parameter: string) {
    try {
      if (parameter) {
        await this.fetch({ parameter: parameter });
      } else {
        await this.fetch();
      }
    } catch (error) {
      throw error;
    }
  }

  async deleteSystemRole(userId: string) {
    try {
      const currentUsser: API_Systemrecht = this.data.find((item) => item.userId === userId);
      const params: API_Systemrecht = {
        id: currentUsser.id,
        userId: userId,
        recht: currentUsser.recht,
      };
      await API.deleteData(API_URL.ADMIN.deleteSystemrole(), params);
      this.fetch();
    } catch (error) {
      throw error;
    }
  }

  toggleSystemRolesModal() {
    this.isSystemRolesModalVisible = !this.isSystemRolesModalVisible;
  }
}

export const systemRolesStore = new SystemRolesStore();
